import React from "react";
import { Button } from "@chakra-ui/react";

const SubmitButton = ({ options }) => {
	//const [disable, setDisable] = React.useState(false);
	const styleClasses = options.styleClasses.length ? options.styleClasses.join(" ") : "";
	return (
		<Button type="submit" className={styleClasses} size="sm" mt="3" colorScheme="blue" 
		//onClick={() => setDisable(true)} disabled={disable}
		>
			{options.name}
		</Button>
	);
};

export default SubmitButton;
